(() => {
  'use strict';
  const KEY = 'kb_home_upsell_intent_v1', SEEN = 'kb_home_upsell_seen_v1', TTL = 2 * 60 * 60 * 1000;
  const categories = {
    houseNumber: /^(oblik-|pojedinacni-karakteri)/,
    doorPlaque: /^(plocica-|plocice-)/,
    mailbox: /^postansko-sanduce$/, dogSign: /^cuvaj-se-psa$/,
    surveillance: /^objekat-je-pod-video-nadzorom$/, parking: /^zabranjeno-parkiranje$/,
    doormat: /^personalizovani-kokos-otirac$/, coasters: /^personalizovani-kameni-podmetaci-za-case$/
  };
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  // --- red cekanja do pristanka ---------------------------------------------
  // Pre pristanka na kolacice `window.gtag` ne postoji, pa bi se dogadjaj
  // izgubio. Cuvamo najvise 30 dogadjaja i saljemo ih cim gtag osvane.
  const red = [];
  let praznjenjeZakazano = false;

  function cekaPristanak() {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      // Ako znamo da je analitika odbijena, ne cuvamo nista.
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === false) {
        return true; // jos uvek cuvamo: posetilac moze da predomisli u baneru
      }
    } catch {}
    return true;
  }

  function uRed(name, payload) {
    if (red.length >= 30) red.shift();
    red.push({ name, payload });
    zakaziPraznjenje();
  }

  function isprazni() {
    if (typeof window.gtag !== 'function') return false;
    while (red.length) {
      const d = red.shift();
      try { window.gtag('event', d.name, d.payload); } catch {}
    }
    return true;
  }

  function zakaziPraznjenje() {
    if (praznjenjeZakazano) return;
    praznjenjeZakazano = true;
    try { document.addEventListener('visitorConsentCollected', () => { setTimeout(isprazni, 300); }, { once: false }); } catch {}
    let pokusaj = 0;
    const tajmer = setInterval(() => {
      pokusaj++;
      // 120 x 500ms = 60s; posle toga odustajemo da ne bismo vrteli zauvek.
      if (isprazni() || pokusaj >= 120) clearInterval(tajmer);
    }, 500);
  }

  function emit(name, data = {}) {
    const payload = { ...data, source: 'upotpunite-dom', upsell_version: 'v2', home_upsell_event: name };
    const page = location.origin + location.pathname;
    function crm(attempt) {
      try {
        if (typeof window.sendEvent === 'function') window.sendEvent('cta_click', payload, {page});
        else if (attempt < 10) setTimeout(() => crm(attempt + 1), 500);
      } catch {}
    }
    crm(0);
    try {
      const dl = (window.dataLayer = window.dataLayer || []);
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, payload);
      } else if (cekaPristanak()) {
        // `window.gtag` postoji tek POSLE prihvatanja kolacica. `home_upsell_view`
        // okida pri ucitavanju, dakle pre nego sto posetilac stigne da klikne
        // „Prihvatite" — i do sada se nepovratno gubio. Zato ga cuvamo i
        // posaljemo kad (i ako) pristanak stigne. Ako pristanka nema, nista se
        // ne salje, sto je i ispravno.
        uRed(name, payload);
      } else {
        // GA4 (G-5YTCSZ03NP) se ucitava kroz GTM kontejner GTM-N4CF9B3, ali u
        // GTM-u NEMA okidaca tipa Custom Event — provereno 05.10.2026. Dogadjaje
        // preuzima gtag.js, koji cita upravo ovaj zapis u obliku `arguments`.
        // Ne dodavati ovde push sa kljucem `event` dok se ne napravi GTM tag:
        // tada bi se isti dogadjaj brojao dvaput.
        (function () { dl.push(arguments); })('event', name, payload);
      }
    } catch (e) {
      if (window.console && console.warn) console.warn('[kb-upsell] slanje dogadjaja nije uspelo:', name, e);
    }
  }
  function begin(category, entry = 'popup') {
    if (!categories[category]) return;
    write(KEY, { category, entry, at: Date.now(), id: crypto.randomUUID() });
  }
  function properties(handle) {
    const intent = read(KEY);
    if (!intent || Date.now() - intent.at > TTL || Date.now() < intent.at || !categories[intent.category]?.test(handle || '')) return {};
    return { _upsell_source: 'upotpunite-dom', _upsell_version: 'v2', _upsell_category: intent.category, _upsell_entry: intent.entry, _upsell_touch_id: intent.id, _upsell_at: String(intent.at), _upsell_base_quantity: '0' };
  }
  function observe(cart) {
    const seen = read(SEEN) || [];
    for (const item of cart.items || []) {
      const props = item.properties || {}, id = props._upsell_touch_id;
      if (!id || props._upsell_source !== 'upotpunite-dom' || props._upsell_base_quantity !== '0' || seen.includes(id)) continue;
      emit('home_upsell_add_to_cart', {product_id:item.product_id,variant_id:item.variant_id || item.id,product_type:props._upsell_category,quantity:item.quantity,value:Number(item.final_line_price ?? item.line_price ?? 0)/100,currency:cart.currency || 'RSD',entry:props._upsell_entry});
      seen.push(id);
      const intent = read(KEY); if (intent?.id === id) { try { sessionStorage.removeItem(KEY); } catch {} }
    }
    write(SEEN, seen.slice(-100));
  }
  window.KBUpsellAttribution = {begin, properties, observe, emit};
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add(?:\.js)?$/.test(new URL(form.action, location.href).pathname)) return;
    const handle = location.pathname.match(/\/products\/([^/]+)/)?.[1];
    const props = properties(handle);
    for (const [key, value] of Object.entries(props)) {
      let input = form.querySelector(`[name="properties[${key}]"]`);
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${key}]`; form.append(input); }
      input.value = value;
    }
  }, true);
})();
